import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Center,
  Flex,
  Heading,
  Spinner,
  Stack,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useMemo, useState } from "react";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import { TiLocationArrow } from "react-icons/ti";
import {
  BusStop,
  BusTime,
  createBusSVG,
  useAllBusLocations,
  useAllBusStops,
  useNearbyBusStops,
} from "../../data/buses.api";
import BusStopPreview from "../../components/buses/BusStopPreview";
import { MapContext } from "../../context/map.context";
import { useNavigate } from "react-router-dom";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import BackButton from "../../components/BackButton";
import { MapPin } from "../../components/Map";
import LocationButton from "../../components/LocationButton";

const NearbyBusStops = () => {
  const {
    setPins,
    watchLocation,
    reset,
    personalLocation,
    location,
    locationError,
  } = useContext(MapContext);
  const {
    data: busStops,
    error,
    isLoading,
  } = useNearbyBusStops(location?.lng, location?.lat);
  const { data: buses } = useAllBusLocations();
  const [busStopsLoading, setBusStopsLoading] = useState(true);
  const [busStopsData, setBusStopsData] = useState<BusStop[]>();
  const [busStopPins, setBusStopPins] = useState<MapPin[]>([]);
  const [busPins, setBusPins] = useState<MapPin[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      setBusStopsLoading(false);
    }
  }, [isLoading]);

  useEffect(() => {
    if (busStops) {
      setBusStopsData(busStops);
    }
  }, [busStops]);

  useEffect(() => {
    if (busStops) {
      setBusStopPins(
        busStops.map((busStop) => ({
          lng: parseFloat(busStop.longitude),
          lat: parseFloat(busStop.latitude),
          onClick: () => navigate(`/buses/${busStop.atcoCode}`),
        }))
      );
    }
  }, [busStops, navigate]);

  useEffect(() => {
    if (buses) {
      setBusPins(
        buses
          .filter((busTime) => busTime.vehicleLocation !== null)
          .map((busTime) => ({
            anchor: "top",
            shake: "circle",
            size: 24,
            imgUrl: createBusSVG(
              busTime.line,
              busTime.vehicleLocation?.bearing
                ? parseInt(busTime.vehicleLocation.bearing)
                : null
            ),
            imgScale: 5,
            color: "transparent",
            lng: busTime.vehicleLocation!.longitude,
            lat: busTime.vehicleLocation!.latitude,
          }))
      );
    }
  }, [buses]);

  useEffect(() => {
    setPins([...busStopPins, ...busPins]);
  }, [busStopPins, busPins, setPins]);

  useEffect(() => {
    watchLocation();
  }, [watchLocation]);

  useEffect(() => {
    return reset;
  }, [reset]);

  return (
    <>
      <HybridBottomSheetDrawer>
        <BackButton />

        <Box p={8}>
          <Flex mb={4} justify="space-between" align="center">
            <Heading size="md">Bus Stops</Heading>
            <LocationButton variant="outline">Nearby</LocationButton>
          </Flex>

          <QueryStateWrapper
            isLoading={busStopsLoading}
            error={error}
            data={busStopsData}
          >
            <Stack spacing={3}>
              {busStopsData?.map((busStop) => (
                <BusStopPreview key={busStop.atcoCode} busStop={busStop} />
              ))}
            </Stack>
          </QueryStateWrapper>
        </Box>
      </HybridBottomSheetDrawer>
    </>
  );
};

export default NearbyBusStops;
